import { Tabs } from "@circleco/compass/components/Tabs";
import type { ChangeEvent, MouseEvent } from "react";
import type { Basic } from "unsplash-js/src/methods/photos/types";

import { t } from "@/i18n-js/instance";

import { EmbedUpload } from "./EmbedUpload";
import { FileUpload } from "./FileUpload";
import { UnsplashTabContent } from "./UnsplashTabContent";

export interface FileUploadMethodsProps {
  addEmbed: (event: MouseEvent<HTMLButtonElement>) => void;
  addUnsplash: (item: Basic) => void;
  aspectRatioHelpText?: string;
  clearError: () => void;
  embedUrl?: string;
  hideEmbedUrl?: boolean;
  hideUnsplash?: boolean;
  imageError?: string;
  insertFiles: (files: FileList | null) => void;
  onChangeEmbedUrl: (event: ChangeEvent<HTMLInputElement>) => void;
}

const TAB_VALUES = {
  upload: "upload",
  unsplash: "unsplash",
  embed: "embed",
} as const;

interface TabsConfig {
  label: string;
  value: string;
}

export const FileUploadMethods = ({
  addEmbed,
  addUnsplash,
  aspectRatioHelpText,
  clearError,
  embedUrl,
  hideEmbedUrl,
  hideUnsplash,
  imageError,
  insertFiles,
  onChangeEmbedUrl,
}: FileUploadMethodsProps) => {
  const tabs: TabsConfig[] = [{ value: TAB_VALUES.upload, label: t("upload") }];

  if (!hideUnsplash) {
    tabs.push({
      value: TAB_VALUES.unsplash,
      label: t("trix_editor.toolbar.unsplash"),
    });
  }

  if (!hideEmbedUrl) {
    tabs.push({
      value: TAB_VALUES.embed,
      label: t("image_upload.embed"),
    });
  }

  return (
    <Tabs.Root
      tabs={tabs}
      defaultValue={TAB_VALUES.upload}
      onValueChange={clearError}
    >
      <Tabs.Panel value={TAB_VALUES.upload}>
        <div className="pt-4">
          <FileUpload
            imageError={imageError}
            insertFiles={insertFiles}
            aspectRatioHelpText={aspectRatioHelpText}
          />
        </div>
      </Tabs.Panel>
      {!hideUnsplash && (
        <Tabs.Panel value={TAB_VALUES.unsplash}>
          <div className="pt-4">
            <UnsplashTabContent addUnsplash={addUnsplash} />
          </div>
        </Tabs.Panel>
      )}
      {!hideEmbedUrl && (
        <Tabs.Panel value={TAB_VALUES.embed}>
          <div className="pt-4">
            <EmbedUpload
              imageError={imageError}
              embedUrl={embedUrl}
              onChangeEmbedUrl={onChangeEmbedUrl}
              addEmbed={addEmbed}
            />
          </div>
        </Tabs.Panel>
      )}
    </Tabs.Root>
  );
};
